var map = {
	"./bg/0.jpg": "ihte",
	"./bg/1.jpg": "TKPw",
	"./bg/2.jpg": "QlXb",
	"./bg/3.jpg": "6nzA",
	"./bg/4.jpg": "4mIo",
	"./bg/5.jpg": "RxOv",
	"./bg/6.jpg": "dUhC",
	"./bg/7.jpg": "8Ktw",
	"./bg/8.jpg": "EZzw",
	"./bg/9.jpg": "nBDd",
	"./default-image.png": "4Rfp",
	"./error.png": "3xxH",
	"./head-bg.jpg": "vSmd",
	"./login/bbg.jpg": "9Orr",
	"./login/bg.png": "yM6R",
	"./login/bg2.png": "DFU6",
	"./login/close.png": "1qGb",
	"./login/df.png": "b+wM",
	"./login/logo.png": "W1y7",
	"./login/logo1.png": "47WN",
	"./login/tc.png": "/Mv+",
	"./login/topbg.jpg": "xBuT",
	"./login/tx.png": "lCk7",
	"./success.png": "mzrL",
	"./wait.png": "18Qj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1